import React, { useEffect, useState } from "react";
import { BottomNav } from "./BottomNav";
import { LangToggle } from "./LangToggle";
import { NotificationBell } from "./NotificationBell";
import { useLang } from "@/i18n";
import { getQueue, syncQueue } from "@/lib/offline";
import { WifiHigh, WifiSlash, ArrowClockwise } from "@phosphor-icons/react";

export function Shell({ children, title, nav = true, back }) {
  const { t } = useLang();
  const [online, setOnline] = useState(navigator.onLine);
  const [pending, setPending] = useState(getQueue().length);

  useEffect(() => {
    const refresh = () => setPending(getQueue().length);
    const goOnline = async () => { setOnline(true); await syncQueue(); refresh(); };
    const goOffline = () => setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    const id = setInterval(refresh, 3000);
    return () => { window.removeEventListener("online", goOnline); window.removeEventListener("offline", goOffline); clearInterval(id); };
  }, []);

  return (
    <div className="max-w-md mx-auto min-h-screen bg-slate-50 flex flex-col">
      <header className="sticky top-0 z-20 bg-white border-b border-slate-200">
        <div className="flex items-center justify-between px-4 h-14">
          <div className="flex items-center gap-2 min-w-0">
            {back}
            <h1 className="font-head font-bold text-lg text-slate-800 truncate">{title}</h1>
          </div>
          <div className="flex items-center gap-1">
            <NotificationBell />
            <LangToggle />
          </div>
        </div>
        <div className={`flex items-center justify-between px-4 py-1 text-xs font-medium ${online ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}`}>
          <span className="flex items-center gap-1">
            {online ? <WifiHigh size={14} /> : <WifiSlash size={14} />}
            {online ? t("online") : t("offline")}
          </span>
          {pending > 0 && (
            <button onClick={async () => { await syncQueue(); setPending(getQueue().length); }} className="flex items-center gap-1" data-testid="sync-retry">
              <ArrowClockwise size={14} /> {pending} {t("sync_pending")}
            </button>
          )}
        </div>
      </header>
      <main className={`flex-1 px-4 py-4 ${nav ? "pb-24" : "pb-6"}`}>{children}</main>
      {nav && <BottomNav />}
    </div>
  );
}
